import {
  LESSON_SIDEBAR_COLLAPSED_WIDTH,
  LESSON_SIDEBAR_WIDTH,
  LESSON_SIDEBAR_WIDTH_LG,
} from '@/components/lesson/LessonCourseSidebar';
import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useMedia } from 'tamagui';

const SIDEBAR_WIDTH_MS = 360;
const SIDEBAR_WIDTH_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

type Props = {
  expanded: boolean;
  children: React.ReactNode;
};

export function LessonSidebarPanel({ expanded, children }: Props) {
  const media = useMedia();
  const expandedWidth = media.gtLg ? LESSON_SIDEBAR_WIDTH_LG : LESSON_SIDEBAR_WIDTH;
  const outerWidth = expanded ? expandedWidth : LESSON_SIDEBAR_COLLAPSED_WIDTH;

  return (
    <View
      style={[
        styles.outer,
        {
          width: outerWidth,
          ...(Platform.OS === 'web'
            ? {
                transitionProperty: 'width',
                transitionDuration: `${SIDEBAR_WIDTH_MS}ms`,
                transitionTimingFunction: SIDEBAR_WIDTH_EASING,
              }
            : null),
        },
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    flexShrink: 0,
    alignSelf: 'stretch',
    backgroundColor: '#FFFFFF',
    borderRightWidth: 1,
    borderRightColor: '#E0DED8',
    overflow: 'hidden',
    position: 'relative',
  },
});
